import React, {SVGProps} from 'react';
import {HexCode} from '@store/@types/util';

interface CircledCheckProps extends SVGProps<any> {
  fill?: HexCode;
}

export const CircledCheck: React.FC<CircledCheckProps> = ({fill = '#F86401', ...props}) => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M20.3044 40.6089C9.10938 40.6089 0 31.5007 0 20.3044C0 9.10774 9.10979 0 20.3044 0C31.5011 0 40.6089 9.10815 40.6089 20.3044C40.6089 31.5011 31.5007 40.6089 20.3044 40.6089ZM20.3044 2.78636C10.6452 2.78636 2.78636 10.6452 2.78636 20.3044C2.78636 29.9648 10.6452 37.8225 20.3044 37.8225C29.9636 37.8225 37.8225 29.9653 37.8225 20.3044C37.8225 10.6452 29.9636 2.78636 20.3044 2.78636Z"
        fill={fill}
      />
      <path
        d="M17.5348 27.0244C17.1648 27.0244 16.8109 26.8771 16.5498 26.616L11.4072 21.4734C10.8643 20.9305 10.8643 20.048 11.4072 19.5035C11.9517 18.9589 12.8342 18.9589 13.3771 19.5035L17.5349 23.6596L27.2019 13.9926C27.7448 13.4497 28.6273 13.4497 29.1718 13.9926C29.7164 14.5372 29.7164 15.4196 29.1718 15.9642L18.52 26.616C18.259 26.877 17.905 27.0244 17.5351 27.0244"
        fill={fill}
      />
    </svg>
  );
};
